import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Property } from './property.interface';
import propertyService from './property.service';

export interface PropertyState {
   properties?: Array<Property>;
}

const PropertyStore: Module<PropertyState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async post(context, { body }: { body: Property }) {
         return propertyService.post(body).then((response) => response);
      },
      async patches(context, { property_id, patches }: { property_id: number; patches: Array<{ path: string; value: any }> }) {
         const BODY = patches.map((patch) => {
            return {
               op: 'replace',
               path: patch.path,
               value: patch.value,
            };
         });

         return await propertyService.patch(property_id, BODY);
      },
      async delete(context, { property_id }: { property_id: number }) {
         return await propertyService.delete(property_id);
      },
   },
};

export default PropertyStore;
